import { createReducer, on, Action } from '@ngrx/store';
import { setLoggedUserData } from './actions';
import { LoginResponse } from '@/auth/interface/auth.interface';

export type State = LoginResponse;

const initialState: LoginResponse = {
  id: 0,
  mdmid: '',
  fullName: '',
  passport: '',
  entity: '',
  management: '',
  shiftWork: '',
  company: '',
  rutDv: '',
  role: '',
  businessUnit: '',
  email: '',
  photo: '',
  area: '',
};

const _reducer = createReducer(
  initialState,
  on(
    setLoggedUserData,
    (state: LoginResponse, payload: LoginResponse) => payload
  )
);

export function reducer(state: typeof initialState = initialState, action: Action) {
  return _reducer(state, action);
}
